import { Box, Typography } from "@mui/material";
import { MessageBubble, MessageContainer } from "./ChatMessage.styled";
import { CONDUCCO_PRIMARY } from "./tokens";

export function LoadingMessage() {
  return (
    <MessageContainer>
      <MessageBubble>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              display: 'flex',
              gap: 0.5,
              '& > div': {
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: CONDUCCO_PRIMARY,
                animation: 'bounce 1.4s infinite ease-in-out both',
              },
              '& > div:nth-of-type(1)': {
                animationDelay: '-0.32s',
              },
              '& > div:nth-of-type(2)': {
                animationDelay: '-0.16s',
              },
              '@keyframes bounce': {
                '0%, 80%, 100%': {
                  transform: 'scale(0)',
                },
                '40%': {
                  transform: 'scale(1)',
                },
              },
            }}
          >
            <div />
            <div />
            <div />
          </Box>
          <Typography variant="body2" color="text.secondary" fontWeight="500">
            Analisando sua pergunta...
          </Typography>
        </Box>
      </MessageBubble>
    </MessageContainer>
  );
}
